/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconMessageCamera = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      d="M13.88 13.64H2.12c-.616 0-1.12-.504-1.12-1.12V5.8c0-.616.504-1.12 1.12-1.12h2.352l1.344-1.344A1.14 1.14 0 0 1 6.656 3h2.8c.28 0 .56.112.784.336l1.344 1.344h2.296c.616 0 1.12.504 1.12 1.12v6.72c0 .616-.504 1.12-1.12 1.12zM8 5.8c-1.68 0-3.08 1.4-3.08 3.08 0 1.68 1.4 3.08 3.08 3.08 1.68 0 3.08-1.4 3.08-3.08C11.08 7.2 9.68 5.8 8 5.8zm0 5.6c-1.4 0-2.52-1.12-2.52-2.52S6.6 6.36 8 6.36s2.52 1.12 2.52 2.52S9.4 11.4 8 11.4z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

IconMessageCamera.displayName = 'IconMessageCamera';

IconMessageCamera.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconMessageCamera);
IconMessageCamera.displayName = 'IconMessageCamera';
